import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ImportPaymentOrderResultDTO  {
    _originalTypeClassName = "zERP.BO.ImportPaymentOrderResultDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ImportPaymentOrderResultDTO.translate = translateService;
}
this.Break = false;
this.ImportPaymentOrderResultDTOKey = null;
this._key = this.ImportPaymentOrderResultDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Break:any;
PaymentOrder:any;
private _ImportPaymentOrderResultDTOKey:any;
get ImportPaymentOrderResultDTOKey(): any {
    return this._ImportPaymentOrderResultDTOKey;
  }
set ImportPaymentOrderResultDTOKey(value: any) {
    this._ImportPaymentOrderResultDTOKey = value;
    this._key = value;
  }
static setPaymentOrder = ($this, value) => {
var oldValue = $this.PaymentOrder;
$this.PaymentOrder = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.ImportPaymentOrderResultDTOKey == null || $this.ImportPaymentOrderResultDTOKey == 0;
            }


}